import { ReactNode } from 'react'
import { connect } from 'react-redux'

import moment from 'moment'

import PageWithBuilding from '../PageWithBuilding'
import { CONNECTION_ERROR } from '../BasePage'

import { STEP_2_VALIDATION_URL } from '../../costants'

import LoginRegister from '../../components/login/LoginRegister'

import Contractor from '../../components/people/contractor/Contractor'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'

import { Place } from '../../components/address/AutoSelectionAddress'

import { getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import SiNo, { SiNoType, getBoolean, getSiNoValue } from '../../components/siNo/SiNo'
import BuildingData from '../../components/building/BuildingData'
import ValueAndDate from '../../components/valueAndDate/ValueAndDate'

import Input from '../../libs/ui/inputs/Input'

import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { authFetch } from '../../libs/cookie/Cookie'

import { NUMBER_PATTERN } from '../../libs/validation/stringRegex'
import { isValidPrivacy } from '../../components/privacy/BasicPrivacy'
import { DATE_PRINT_FORMAT, isNotValidInizioPolizza } from '../../libs/validation/dateValidation'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import { getAnniCasa, getTipiCasa, getUtilizziCasa } from '../../libs/initialization/remoteInits'

import { FirePageState, FirePageProps, firePageInitialState, fireUpdate } from './FirePageSilce'

import { ADDRESS_SEARCH_URL } from '../../costants'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class FirePage extends PageWithBuilding<FirePageProps, FirePageState> {

    constructor (props: any) {
        super(props)

        this.state = {
            ...firePageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updatePolizzaMutuo = this.updatePolizzaMutuo.bind(this)
        this.updateDurata_mutuo = this.updateDurata_mutuo.bind(this)
        this.updateData_surroga = this.updateData_surroga.bind(this)

        this.step2Validation = this.step2Validation.bind(this)
        this.durataMutuoValidation = this.durataMutuoValidation.bind(this)

        this.updateIsManualAddress = this.updateIsManualAddress.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.anni === undefined) {
            getAnniCasa (this.updateAnni, this.manageExpiredSessions)
        }
        if (this.state.utilizzi === undefined) {
            getUtilizziCasa (this.updateUtilizzi, this.manageExpiredSessions)
        }
        if (this.state.tipologie === undefined) {
            getTipiCasa (this.updateTipologie, this.manageExpiredSessions)
        }
    }

    componentDidUpdate(prevProps: Readonly<FirePageProps>, prevState: Readonly<FirePageState>, snapshot?: any): void {
        super.componentDidUpdate (prevProps, prevState, snapshot)

        if (prevState.isRistrutturato !== this.state.isRistrutturato) {
            // se ho cambiato valore pulisco i campi dipendenti
            this.saveStateAndRedux({
                anno_ristrutturazione: undefined,
                anno_ristrutturazioneError: undefined
            })
        }
    }

    render () : ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="fire_form">
                                
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >

                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={true}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}

                                            hideAltriSinistri={true}
                                        />

                                        <BuildingData 
                                            superfice={this.state.metri_quadri}
                                            uso={this.state.tipo_uso}
                                            tipo={this.state.tipo_immobile}
                                            piani={this.state.numero_piani}
                                            piano={this.state.piano_abitazione}
                                            
                                            annoCostruzione={this.state.anno_costruzione}
                                            isRistrutturato={this.state.isRistrutturato}
                                            annoRistrutturazione={this.state.anno_ristrutturazione}
                                            
                                            indirizzo={this.state.indirizzo}
                                            street={this.state.street}
                                            street_number={this.state.street_number}
                                            zip={this.state.zip}
                                            city={this.state.city}

                                            is_manual_address={this.state.is_manual_address}
                                            updateManualSelectionCallBack={this.updateIsManualAddress}

                                            anni={this.state.anni}
                                            utilizzi={this.state.utilizzi}
                                            tipologie={this.state.tipologie}

                                            superficeError={this.state.metri_quadriError}
                                            usoError={this.state.tipo_usoError}
                                            tipoError={this.state.tipo_immobileError}
                                            pianiError={this.state.numero_pianiError}
                                            pianoError={this.state.piano_abitazioneError}
                                            annoCostruzioneError={this.state.anno_costruzioneError}
                                            isRistrutturatoError={this.state.isRistrutturatoError}
                                            annoRistrutturazioneError={this.state.anno_ristrutturazioneError}

                                            indirizzoError={this.state.indirizzoError}
                                            streetError={this.state.streetError}
                                            street_numberError={this.state.street_numberError}
                                            zipError={this.state.zipError}
                                            cityError={this.state.cityError}

                                            updateSuperficeCallBack={this.updateMetri_quadri}
                                            updateUsoCallBack={this.updateTipo_uso}
                                            updateTipoCallBack={this.updateTipo_immobile}
                                            updatePianiCallBack={this.updateNumero_piani}
                                            updatePianoCallBack={this.updatePiano_abitazione}
                                            
                                            updateAnnoCostruzioneCallBack={this.updateAnno_costruzione}
                                            updateIsRistrutturato={this.updateIsRistrutturato}
                                            updateAnnoRistrutturazione={this.updateAnno_ristrutturazione}

                                            updateAll={this.updateAll}
                                            updateStreet={this.updateStreet}
                                            updateNumber={this.updateStreet_number}
                                            updateZip={this.updateZip}
                                            updateCity={this.updateCity}

                                            expiredSessionCallbak={this.manageExpiredSessions}
                                            annoRistrutturazioneValidationCallback={this.validaeAnnoRistrutturazione}
                                        />

                                        <SiNo 
                                            id='obbligo_polizza_mutuo' name="obbligo_polizza_mutuo"
                                            label='Serve come polizza obbligatoria per la banca?'
                                            value={ getSiNoValue( this.state.polizza_mutuo ) }
                                            callback={this.updatePolizzaMutuo}
                                            error={this.state.polizza_mutuoError}
                                        />

                                        { this.state.polizza_mutuo &&
                                            <div className='col-12'>
                                                <Input 
                                                    id='durata_mutuo' name='durata_mutuo'
                                                    label='Durata del mutuo'
                                                    value={this.state.durata_mutuo?.toString()}
                                                    type='number'
                                                    step='1' maxLength={2} min='1' max='99'
                                                    callback={this.updateDurata_mutuo}
                                                    regexp={NUMBER_PATTERN}
                                                    remoteValidation={this.durataMutuoValidation}
                                                    error={this.state.durata_mutuoError}
                                                    onInput={
                                                        (e: any) => e.currentTarget.value = (e.currentTarget.value ?? '').replace(/^0+/, "").slice(0,2)
                                                    }
                                                />
                                            </div>
                                        }

                                        <ValueAndDate 
                                            valore={this.state.valore_perizia}
                                            valoreId="perizia"
                                            valoreLabel={
                                                this.state.polizza_mutuo === true
                                                    ? "Valore di perizia dell'immobile (€)"
                                                    : "Valore stimato dell'immobile (€)"
                                            }
                                            valoreError={this.state.valore_periziaError}
                                            updateValoreCallBack={this.updateValore_perizia}

                                            data={this.state.data_surroga}
                                            dataId={"data_surroga"}
                                            dataLabel={
                                                this.state.polizza_mutuo === true
                                                    ? "Data presunta di rogito o surroga"
                                                    : "Data di decorrenza nuova polizza"
                                            }
                                            dataError={this.state.data_surrogaError}
                                            updateDataCallBack={this.updateData_surroga}

                                            showDate={this.state.polizza_mutuo ?? false}
                                        />

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={ isLogged }
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />

                                    </SinglePage>

                                </Pagination>

                            </form>

                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    getInitialState() {
        return firePageInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
        ])
        .then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }

            return {
                errorString: e,
                pageError: p
            }
        })
        .catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        } 
        else {
            let superficeErro = undefined
            let usoErro = undefined
            let tipoErro = undefined
            let pianiErro = undefined
            let pianoErro = undefined
            let annoCostruzioneErro = undefined
            let isRistrutturatoErro = undefined
            let annoRistrutturazioneErro = undefined
            let indirizzoErro = undefined
            let polizza_mutuoErro = undefined
            let durata_mutuoErro = undefined

            let periziaErro = undefined
            let data_surrogaErro = undefined

            let global = undefined

            const NOW = new Date()
            const DATE_START_FORMATTED = moment(NOW).format(DATE_PRINT_FORMAT)
            
            const invalidString = 'Valore non valido'

            if (errorString === 'METRI_QUADRI') {
                superficeErro = invalidString
                global = 'Indicare la superficie del immobile'
            }
            else if (errorString === 'TIPO_USO') {
                usoErro = invalidString
                global = "Indicare l'utilizzo del immobile"
            }
            else if (errorString === 'TIPO_IMMOBILE') {
                tipoErro = invalidString
                global = 'Indicare la tipologia del immobile'
            }
            else if (errorString === 'NUMERO_PIANI') {
                pianiErro = invalidString
                global = 'Indicare il numero di piani dello stabile'
            }
            else if (errorString === 'PIANO_ABITAZIONE') {
                pianoErro = invalidString
                global = "Indicare il piano a cui si trova l'immobile"
            }
            else if (errorString === 'ANNO_COSTRUZIONE') {
                annoCostruzioneErro = invalidString
                global = 'Selezionare il periodo di costruzione del immobile'
            }
            else if (errorString === 'IS_RISTRUTTURATO') {
                isRistrutturatoErro = 'Selezionare un valore'
                global = "Indicare se l'immobile è stato ristrutturato"
            }
            else if (errorString === 'ANNO_RISTRUTTURAZIONE') {
                annoRistrutturazioneErro = invalidString
                global = "Indicare l'anno di ristrutturazione del immobile"
            }
            else if (errorString === 'INDIRIZZO' || errorString === 'BUILD_ADDRESS_NOT_FOUND') {
                indirizzoErro = invalidString
                global = (errorString === 'BUILD_ADDRESS_NOT_FOUND') 
                            ? 'Indirizzo non trovato, ti preghiamo di inserirlo tramite il tasto "Compilazione manuale".'
                            : "Indicare l'indirizzo in cui è sito l'immobile"
            }
            else if (errorString === 'POLIZZA_MUTUO') {
                polizza_mutuoErro = invalidString
                global = "Indicare se la polizza è necessaria per stipulare un mutuo"
            }
            else if (errorString === 'DURATA_MUTUO') {
                durata_mutuoErro = invalidString
                global = "Indicare la durata del mutuo"
            }
            else if (errorString === 'VALORE_PERIZIA') {
                periziaErro = invalidString
                global = "Indicare il valore dell'immobile"
            }
            else if (errorString === 'DATA_SURROGA') {
                const DATE_END_FORMATTED = moment(NOW).add(1, 'year').format(DATE_PRINT_FORMAT)

                data_surrogaErro = invalidString
                global = 'Inserire una data tra ' + DATE_START_FORMATTED + ' e ' + DATE_END_FORMATTED
            }
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                metri_quadriError: superficeErro,
                tipo_usoError: usoErro,
                tipo_immobileError: tipoErro,
                numero_pianiError: pianiErro,
                piano_abitazioneError: pianoErro,
                anno_costruzioneError: annoCostruzioneErro,
                isRistrutturatoError: isRistrutturatoErro,
                anno_ristrutturazioneError: annoRistrutturazioneErro,
                indirizzoError: indirizzoErro,
                polizza_mutuoError: polizza_mutuoErro,
                durata_mutuoError: durata_mutuoErro,
                data_surrogaError: data_surrogaErro,
                valore_periziaError: periziaErro,
                
                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        const isAppartamento = this.state.tipo_immobile === 'appartamento'

        return {
            sinistriPrecedenti: false, // VALORE defaultato --> https://app.clickup.com/t/86bwjrc80
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            metri_quadri: this.state.metri_quadri ?? null,
            tipo_uso: this.state.tipo_uso ?? null,
            tipo_immobile: this.state.tipo_immobile ?? null,
            numero_piani: isAppartamento ? (this.state.numero_piani ?? null) : null,
            piano_abitazione: isAppartamento ? (this.state.piano_abitazione ?? null) : null,
            
            anno_costruzione: this.state.anno_costruzione ?? null,
            anno_ristrutturazione: this.state.anno_ristrutturazione ?? null,

            indirizzo: this.state.indirizzo ?? null,
            
            polizza_mutuo: this.state.polizza_mutuo ?? null,
            data_surroga: this.state.data_surroga ?? null,
            durata_mutuo: this.state.durata_mutuo ?? null,
            valore_perizia: this.state.valore_perizia ?? null,
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    fireUpdate (this.state)
                )
            }
        )
    }
    
    private updatePolizzaMutuo (val: SiNoType) {
        const boolValue = getBoolean( val )

        let next = {
            polizza_mutuo: boolValue,
            polizza_mutuoError: undefined
        }

        if (boolValue === false) {
            next = {
                ...next,
                ...{ 
                    durata_mutuo: undefined, 
                    durata_mutuoError: undefined,
                    data_surroga: undefined, 
                    data_surrogaError: undefined
                }
            }
        }

        this.saveStateAndRedux( next )
    }
    private updateDurata_mutuo (val: number | undefined) {
        this.saveStateAndRedux({
            durata_mutuo: val,
            durata_mutuoError: undefined
        })
    }
    private updateData_surroga (val: string | undefined) {
        this.saveStateAndRedux({
            data_surroga: val,
            data_surrogaError: undefined
        })
    }

    private async step2Validation () {
        let error = this.commonStep2Validation(
            true // valida il valore del immobile
        )

        if (error) {
            this.printError(error, false, 2)
            return error
        }

        if (this.state.polizza_mutuo === undefined) {
           error = 'POLIZZA_MUTUO'
        }
        else if (
            this.state.polizza_mutuo === true && 
            (this.state.durata_mutuo === undefined || Number(this.state.durata_mutuo) < 1 || Number(this.state.durata_mutuo) > 99)
        ) {
           error = 'DURATA_MUTUO'
        }
        else if (
            this.state.polizza_mutuo === true && 
            isNotValidInizioPolizza( this.state.data_surroga )
        ) {
            error = 'DATA_SURROGA'
        }

        else if (!isValidPrivacy(this.state.noMotorPrivacy, this.state.user !== undefined)) {
            error = 'PRIVACY'
        }
        
        else {
            const abortController = new AbortController()

            if (this.state.is_manual_address !== true) {
                await authFetch (
                    ADDRESS_SEARCH_URL,
                    {
                        method: 'post',
                        body: JSON.stringify( this.state.indirizzo ),
                        signal: abortController?.signal
                    },
                    this.manageExpiredSessions
                ).then( (res: any) => {
                    let palces = (res.placeList as Array<any>)

                    let hearAddress = this.state.indirizzo
                    hearAddress = hearAddress?.replace("(", "").replace(")", "")

                    if (palces === undefined || !palces.some ( (c: Place) => c.description.toUpperCase() === hearAddress )) {
                        console.log (
                            hearAddress,
                            palces
                        )
                        error = 'BUILD_ADDRESS_NOT_FOUND'    
                    }
                }).catch( async (err) => {
                    error = 'BUILD_ADDRESS_NOT_FOUND'
                })
            }
                
            if (error === undefined) {
                await authFetch (
                    STEP_2_VALIDATION_URL,
                    {
                        method: "post",
                        body: JSON.stringify({
                            specificData: this.getSpecificDataForSubmit(),
                            privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
                            isLogged: this.state.expiredSessionError === false ? this.state.user !== undefined : false
                        })
                    },
                    this.manageExpiredSessions,
                ).then ( jsonObj => {
                    if (jsonObj.status > 200) {
                        error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                    }
                }).catch( error => {
                    error = CONNECTION_ERROR
                })
            }
            
        }

        this.printError(error)

        return error
    }

    private durataMutuoValidation (value: number | undefined) {
        return (value && (Number(value) < 0 || Number(value) > 99)) ? 'Valore non valido' : undefined
    }

    private updateIsManualAddress ( val: boolean) {
        this.setState({
            is_manual_address: val
        })
    }
}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    metri_quadri: state.metri_quadri,
    tipo_uso: state.tipo_uso,
    tipo_immobile: state.tipo_immobile,
    numero_piani: state.numero_piani,
    piano_abitazione: state.piano_abitazione,

    anno_costruzione: state.anno_costruzione,
    isRistrutturato: state.isRistrutturato,
    anno_ristrutturazione: state.anno_ristrutturazione,
    
    indirizzo: state.indirizzo,
    
    polizza_mutuo: state.polizza_mutuo,
    data_surroga: state.data_surroga,
    durata_mutuo: state.durata_mutuo,
    valore_perizia: state.valore_perizia,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user
  }
}

export default connect(mapState) (FirePage)